<template>
  <div>
    <v-dialog v-model="isShowDialog" max-width="500">
      <v-card>
        <v-card-title>
          <h3>Dudas y consultas</h3>
        </v-card-title>
        <v-card-text class="phones">
          <!-- <div>
            Si no recuerda su código de postulante
            <a
              target="__blank"
              href="https://posgrado.unmsm.edu.pe/admision/consultas/Consulta_Postulantes/index.php"
              >ingrese aquí</a
            >
          </div> -->
          <p>Para preguntas frecuentes:
            <a
              target="__blank"
              href="https://posgrado.unmsm.edu.pe/admision-evam-pf/"
              >ingrese aquí</a
            >
          </p>
          <div>
            <p>Para consulta del examen:</p>
            <p>
              <v-icon>mdi-phone</v-icon><strong class="ml-1">Teléfonos:</strong>
              960125776 | 980394295 | 996431501
            </p>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="blue" text @click="isShowDialog = false">Entendido</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-fab-transition>
      <v-btn
        v-show="!hidden"
        color="blue"
        dark
        fab
        :class="{'btn-scroll': isFixed}"
        :width="size"
        :height="size"
        @click="isShowDialog = true"
      >
        <v-icon>mdi-help</v-icon>
      </v-btn>
    </v-fab-transition>
  </div>
</template>

<script>
export default {
  props: {
    size: {
      type: Number,
      default: 50
    },
    isFixed: {
      type: Boolean,
      default: true
    }
  },
  data: () => {
    return {
      hidden: false,
      isShowDialog: false,
    };
  },
  name: "ScrollButton",
};
</script>

<style lang="css" scoped>
.btn-scroll {
  position: fixed;
  bottom: 10px;
  right: 40px;
  z-index:100;
}
</style>